import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const Arrow = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg viewBox='0 0 16 16' fill='currentColor' xmlns='http://www.w3.org/2000/svg' {...props} ref={ref}>
        <g clipPath='url(#clip0_2112_259288)'>
            <path
                d='M4.94 10.2733L8 7.21992L11.06 10.2733L12 9.33325L8 5.33325L4 9.33325L4.94 10.2733Z'
                fill='currentColor'
            />
        </g>
        <defs>
            <clipPath id='clip0_2112_259288'>
                <rect fill='currentColor' width={props.width} height={props.height} />
            </clipPath>
        </defs>
    </svg>
));
